import React from 'react';
import { useParams } from 'react-router-dom';
import RoadmapForm from '../../components/diagnosis/RoadmapForm';
import './RoadmapPage.css';

const RoadmapPage = () => {
    const { reportId } = useParams();

    return (
        <div className="roadmap-page">
            <div className="roadmap-main-content">
                <RoadmapForm reportId={reportId} />
            </div>
        </div>
    );
};

export default RoadmapPage;
